const getText = (value) => {
  if (typeof value === 'string') return value
  return value?.text || ''
}

export const getVenderWelcomeInfo = (vender) => {
  const welcomeInfoSetting = vender?.welcomeInfoSetting || {}
  const typicalImages = welcomeInfoSetting?.typicalImages || {}

  return {
    logoImage: welcomeInfoSetting?.logo?.image || null,
    typicalImage: typicalImages?.typicalImage || null,
    typicalMobileImage: typicalImages?.typicalMobileImage || null,
    announcementText: getText(welcomeInfoSetting?.announcement),
    favorableDiscountText: getText(welcomeInfoSetting?.favorableDiscount),
    brieflyDescribeText: getText(welcomeInfoSetting?.brieflyDescribe),
  }
}
